import { HeaderMenu } from '../components/menu/header-menu';
import { ABCList } from '../components/abc-list/abc-list';

new HeaderMenu();
new ABCList();
